import * as z from "zod";

export const suppresionValidation = z.object({
  email: z.enum(["PYEM", "PNEM", "PUEM"]),
  phone: z.enum(["PNPH", "LIPH"]),
  post: z.enum(["PNPO", "LIPO"]),
  text: z.enum(["PYSM", "PNSM", "PUSM"]),
});

export default suppresionValidation;
